import styled from 'styled-components'

import { mediaQueries, palette } from '../../styles/variables'

export const LayoutWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const Body = styled.div({
  display: 'flex',
})

export const Page = styled.div((props) => ({
  flex: 1,
  width: props.collapse ? 'calc(100% - 84px)' : 'calc(100% - 220px)',
  overflow: 'auto',
  [mediaQueries.tablet]: {
    width: 'calc(100% - 84px)',
  },
}))

export const EmailConfirmAlert = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  background: palette.blue10,
  border: `1px solid ${palette.lightGray70}`,
  padding: '12px 24px',
  zIndex: 120,
  [mediaQueries.mobile]: {
    padding: '10px 15px',
    flexDirection: 'column',
  },
}))

export const EmailConfirmText = styled.div(() => ({
  marginRight: '16px',
}))
